module.exports = __webpack_public_path__ + "img/location-pin.b07a9466.svg";